import { createSortOption } from "@nosto/preact"

export const sizes = [24, 48, 72]

export const sortOptions = [
    createSortOption("score", "Relevancia", { field: "score", order: "desc" }),
    createSortOption("price", "Precio, menor a mayor", { field: "price", order: "asc" }),
    createSortOption("-price", "Precio, mayor a menor", { field: "price", order: "desc" }),
    // createSortOption("newest", "Newest First", { field: "datePublished", order: "asc" }),
    // createSortOption("oldest", "Oldest First", { field: "datePublished", order: "desc" }),
    // createSortOption("name", "A-Z", { field: "name", order: "asc" }),
    // createSortOption("-name", "Z-A", { field: "name", order: "desc" }),
    // createSortOption("rating", "Top Rated: Lowest - Highest", { field: "ratingValue", order: "asc" }),
    // createSortOption("-rating", "Top Rated: Highest - Lowest", { field: "ratingValue", order: "desc" }),
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[0],
    autocompleteProductsSize: 10,
    autocompleteKeywordsSize: 10,
    historySize: 5,
}

export const topSearches = [
    { text: "iPhone 16", url: "/products/iphone-16-myec3be-a" },
    { text: "macbook", url: "/pages/mac" },
    { text: "iPad", url: "/pages/ipad" },
    { text: "apple watch" },
]

export const SEARCH_ONSITE_TAG_SELECTOR = "nosto_search_term";
export const DROPDOWN_REC_ID = "searchdropdown-nosto-1";